

















































import { Vue, Component, Mixins } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import Form from '@/mixins/form';

@Component
export default class LoginForm extends Mixins(Form)
{
    public passwordHidden: boolean = true;

    public form: any = {
        email: null,
        password: null
    }

    created() {
        this.form.email = this.$route.query.email || null
    }

    public submit(): void {

        if (!this.$refs.form.validate()) {
            this.loading = false;
            return;
        } 

        this.loading = true;

        axios.post(api.path('v1.login'), this.form)
            .then( res => {
                this.$emit('success', res.data);
            })
            .catch(err => {
                this.handleErrors(err.response.data.errors);
            })
            .then(() => {
                this.loading = false
            });
    }
}
